// Shared schema field normalization

import {
  formatOcrDate,
  normalizeGender,
  sanitizeCnicInput,
} from "./normalizers";

const GENDER_FIELD_KEYS = new Set(["gender", "sex"]);

const EXTRACTED_FIELD_ALIASES = {
  gender: ["sex"],
  sex: ["gender"],
};

const hasExtractedValue = (value) =>
  value != null && String(value).trim().length > 0;

export const resolveExtractedRawValue = (data, key) => {
  if (!data) return null;
  if (hasExtractedValue(data[key])) return data[key];
  for (const alias of EXTRACTED_FIELD_ALIASES[key] || []) {
    if (hasExtractedValue(data[alias])) return data[alias];
  }
  return null;
};

export const normalizeExtractedFieldValue = (fieldDef, rawValue) => {
  if (!fieldDef || rawValue == null) return "";
  let value = String(rawValue).trim();
  if (!value) return "";

  if (fieldDef.inputType === "date") {
    return formatOcrDate(value) || value;
  }

  if (fieldDef.inputType === "select") {
    if (GENDER_FIELD_KEYS.has(fieldDef.key)) {
      const normalized = normalizeGender(value);
      if (normalized) return normalized;
    }
    const options = fieldDef.options || [];
    const match = options.find(
      (option) => option.toLowerCase() === value.toLowerCase(),
    );
    return match || value;
  }

  if (fieldDef.key === "id_card_number") {
    return sanitizeCnicInput(value) || value;
  }

  return value;
};

export const normalizeExtractedField = (fieldDef, data) =>
  normalizeExtractedFieldValue(
    fieldDef,
    resolveExtractedRawValue(data, fieldDef.key),
  );

export const normalizeFieldsFromSchema = (schema, data, _rawText = "") => {
  if (!schema) return data || {};
  const normalized = { ...(data || {}) };

  schema.fields.forEach((def) => {
    normalized[def.key] = normalizeExtractedField(def, data);
  });

  return normalized;
};
